import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { Crons, PriceLimits, ProgramConfig, Site } from '@model';
import { TreeService } from '@service';

enum Modes {
  details = 'details',
  configure = 'configure',
  events = 'events',
}

@Component({
  selector: 'bmd-site',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  styleUrls: ['./site.component.scss'],
  templateUrl: './site.component.html',
})
export class SiteComponent implements OnInit, OnDestroy {
  tabsEnum: typeof Modes = Modes;
  mode: Modes = Modes.details;
  site: Site;
  apiKey: string;
  crons: Crons = new Crons();
  priceLimits: PriceLimits;
  saving = false;
  siteForm: FormGroup;
  programConfig: ProgramConfig;

  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private treeService: TreeService,
  ) {
    this.siteForm = new FormGroup({
      ercotMaxPrice: new FormControl(),
      ercotMinPrice: new FormControl(),
      maxEcrsMw: new FormControl(),
      maxNsrsMw: new FormControl(),
      maxRegdownMw: new FormControl(),
      maxRegupMw: new FormControl(),
      maxRrsMw: new FormControl(),
      operationCostPerMWh: new FormControl(),
    });
  }

  public get Modes() {
    return Modes;
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.route.data.subscribe(data => {
        const siteObs: Observable<Site> = data['data'][0];
        const crons: Crons = data['data'][1];
        const priceLimits: PriceLimits = data['data'][3];

        siteObs.subscribe(site => {
          console.log('loaded site');
          this.site = site;
          this.programConfig = data['data'][2];
          this.siteForm.patchValue(site.config);

          this.treeService.selectSiteInList(site);
          if (!site.deviceId) {
            return;
          }
        });

        this.crons = crons;
        this.priceLimits = priceLimits;
        this.siteForm
          .get('ercotMinPrice')
          .setValidators([Validators.min(priceLimits.min), Validators.max(priceLimits.max)]);
        this.siteForm
          .get('ercotMaxPrice')
          .setValidators([Validators.min(priceLimits.min), Validators.max(priceLimits.max)]);
      }),

      this.route.queryParams.subscribe(params => {
        const tab = params['tab'];
        this.mode = tab === Modes.details.toString() || tab === Modes.events.toString() ? Modes[tab] : Modes.configure;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  changeMode(mode: Modes): void {
    this.mode = mode;
    this.appendModeToQueryParam(mode);
  }

  private appendModeToQueryParam(mode: Modes): void {
    this.router.navigate([], {
      queryParams: {
        tab: mode,
      },
      queryParamsHandling: 'merge',
      relativeTo: this.route,
      // preserve the existing query params in the route
      // skipLocationChange: true,
      // do not trigger navigation
    });
  }
}
